import { useDispatch, useSelector } from "react-redux";
import dynamicfunction from "../../utils/dynamicfunction";
import { useEffect, useState } from "react";
import { getContentKeyAccToLang } from "../../utils/utils";
import {
  createRedemption,
  getFundDropdowns,
} from "../../store/actions/fund-action";
import { setFundHoldings } from "../../store/slices/fund-slice";
import { generateGeneralOtp } from "../../store/actions/common-action";

export default () => {
  const dispatch = useDispatch();
  const { TextWeight, isArabic } = dynamicfunction();
  const { fundsContent } = useSelector((state) => state.content);
  const { fund_loading, dropdown_data, fund_holdings, tradex_details } =
    useSelector((state) => state.fund);

  const [isPartial, setIsPartial] = useState(true);
  const [redeemData, setRadeemData] = useState();
  const [reviewModal, setReviewModal] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [otpModal, setOtpModal] = useState(false);

  useEffect(() => {
    dispatch(getFundDropdowns());
    dispatch(setFundHoldings(null));
  }, []);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      fundsContent?.web_funds_radeem?.data?.attributes,
      key,
      isArabic
    );
  };

  const toogleReviewModal = () => setReviewModal(!reviewModal);
  const toogleOtpModal = () => setOtpModal(!otpModal);

  const handleReview = (values, functions) => {
    try {
      const per_unit =
        Number(fund_holdings?.currentMarketValue) /
        Number(fund_holdings?.totalUnits);
      const amountByQuantity = Number(values?.quantity) * per_unit;
      if (
        values?.redemption &&
        Number(values?.redemption) <
          Number(tradex_details?.minimumRedemptionAmount)
      ) {
        functions.setFieldError(
          "redemption",
          "cash_suffiecient"
        );
      } else if (
        values?.quantity &&
        amountByQuantity < Number(tradex_details?.minimumRedemptionAmount)
      ) {
        functions.setFieldError(
          "quantity",
          "cash_suffiecient"
        );
      } else {
        setRadeemData({ ...values, resetForm: functions?.resetForm });
        toogleReviewModal();
      }
    } catch (error) {
    }
  };

  const onSubmitReview = () => {
    onVerifyOtp()
    // toogleReviewModal();
    // toogleOtpModal();
    // dispatch(generateGeneralOtp());
  };

  const onVerifyOtp = () => {
    const per_unit =
      Number(fund_holdings?.currentMarketValue) /
      Number(fund_holdings?.totalUnits);
    const amountByQuantity = Number(redeemData?.quantity) * per_unit;
    const quantityByAmount = Number(redeemData?.redemption) / per_unit;

    const api_data = {
      fundCode: redeemData?.fund?.fundCode,
      cashAccountCode: redeemData?.transfer?.code,
      assetClassCode: redeemData?.asset_code?.code,
      // class: redeemData?.class?.name?.toString(),
      redemptionAmount: isPartial ? redeemData?.quantity?.length > 0 ? amountByQuantity : Number(redeemData?.redemption) : fund_holdings?.currentMarketValue,
      redemptionUnits: isPartial ? redeemData?.quantity?.length > 0 ? Number(redeemData?.quantity) : quantityByAmount : fund_holdings?.totalUnits,
      redemptionType: isPartial ? "partial" : "full",
      redemptionValueType: redeemData?.quantity?.length > 0 ? "Units" : "Amount",
    };

    dispatch(
      createRedemption(api_data, () => {
        setRadeemData(null);
        toogleReviewModal();
        redeemData?.resetForm();
        setIsCompleted(true);
      })
    );
  };

  return {
    TextWeight,
    isArabic,
    redeemData,
    isPartial,
    dropdown_data,
    fund_loading,
    isCompleted,
    setIsPartial,
    getContentKey,
    handleReview,
    onSubmitReview,
    dispatch,
    fund_holdings,
    reviewModal,
    toogleReviewModal,
    otpModal,
    toogleOtpModal,
    onVerifyOtp,
  };
};
